import React from 'react'

import Section from '../Section'

import customIcon from 'assets/images/contacts/Editor/editor-custom-20.svg'
import { useTranslation } from 'react-i18next'

interface CustomsProps {
  editData: any
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
}

const Customs = ({ editData, onFieldChange, onLabelChange, onAddItem, onDelete }: CustomsProps) => {
  const { t } = useTranslation()
  return (
    <Section
      editData={editData}
      propName="customs"
      labelList={[
        { key: '', label: t('contact.property.none') },
        { key: 'custom', label: t('contact.property.custom') },
      ]}
      icon={customIcon}
      addButtonLabel={t('contact.menu.addCustom')}
      onFieldChange={onFieldChange}
      onLabelChange={onLabelChange}
      onAddItem={onAddItem}
      onDelete={onDelete}
      canDelete={(_) => true}
    />
  )
}
export default Customs
